import { useEffect, useState } from "react";
import { useUser } from "../contexts/UserContext";

import TitleBar from "../components/TitleBar/TitleBar";

import "./ArtCollection.css";
import { GachaUserData } from "@mythic/coms/types";
import { useNavigate } from "react-router-dom";

interface gachaItem {
    id: string;
    name: string;
    rarity: number;
    imageUrl: string;
}

interface userData {
    userId: string;
    displayName: string;
    profileImageUrl: string;
    owned: gachaItem[];
    items: string[];
}

async function fetchUser(id: string): Promise<GachaUserData | null> {
    const res = await fetch(
        `${import.meta.env.VITE_SERVER_URL}/api/gacha/${id}/get`,
        {
            credentials: "include",
            method: "GET",
        },
    );
    const json = await res.json();

    if (json.ok === false) return null;

    return json.user as GachaUserData;
}

export function ArtCollection() {
    const [userData, setUserData] = useState<GachaUserData | null>(null);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const navigate = useNavigate();

    const { user } = useUser();

    // fetch the art collection for the user
    useEffect(() => {
        const url = new URL(window.location.href);
        const userId = url.searchParams.get("userId");

        if (!userId) {
            navigate({ search: `?userId=${user.id}` });
        }

        const getUserData = async () => {
            let gachaUser: GachaUserData | null = null;
            if (userId) gachaUser = await fetchUser(userId);
            if (gachaUser === null && user !== null)
                gachaUser = await fetchUser(user.id);

            setUserData(gachaUser);
            if (gachaUser?.items) setSelectedImage(gachaUser?.items[0]);
        };

        getUserData();
    }, []);

    if (!userData) {
        return (
            <>
                <TitleBar title="Art Collection" />
            </>
        );
    }

    return (
        <div className="art-collection">
            <TitleBar
                title={
                    userData
                        ? `${userData.displayName}'s Art Collection`
                        : "Art Collection"
                }
            />
            {userData && userData.items.length > 0 && (
                <div className="art-selection">
                    {userData.owned.map((item, index) => (
                        <div key={item.id} className="art-item">
                            <img
                                className={`selection-image${selectedImage === item.id ? " selected" : ""}`}
                                src={`${import.meta.env.VITE_SERVER_URL}${item.imageUrl}`}
                                alt={item.name}
                                onClick={() => {
                                    setSelectedImage(item.id);
                                }}
                            />
                        </div>
                    ))}
                </div>
            )}
            {userData && selectedImage && (
                <div className="image-modal">
                    <h2 style={{ margin: 0 }}>
                        {
                            userData.owned.find(
                                (item) => item.id === selectedImage,
                            )?.name
                        }
                    </h2>
                    <img
                        className="large-gacha-image"
                        src={`${import.meta.env.VITE_SERVER_URL}${userData.owned.find((item) => item.id === selectedImage)?.imageUrl}`}
                        alt="Selected Art"
                    />
                </div>
            )}
        </div>
    );
}
